import React, {useState, useEffect} from "react";
import "./PreviewPopup.css";

const PreviewPopup = ({ file, onClose }) => {
  const [fileUrl, setFileUrl] = useState(null);

  useEffect(() => {
    if (file) {
      const url = URL.createObjectURL(file);
      setFileUrl(url);

      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [file]);
  return (
    <div className="preview-popup">
      <div className="preview-content">
        <div>
          <iframe
            className="preview"
            style={{
              width: "100%",
              height: "500px",
              border: "none",
              background: "none",
            }}
            src={fileUrl}
          ></iframe>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button className="close-preview-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreviewPopup;
